import { useState, useEffect } from 'react'

// You can use this hook to conditionally render components based on media queries
export default function useMediaQuery(query) {
  // Start from the real answer. Starting from false rendered the narrow
  // layout for one frame on every wide screen, then swapped it, remounting
  // whatever was inside.
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== matches) {
      setMatches(media.matches)
    }
    const listener = () => {
      setMatches(media.matches)
    }

    if (media.addEventListener) {
      media.addEventListener('change', listener)
    }
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener)
      }
    }
  }, [matches, query])

  return matches
}
